import React, { Fragment } from 'react'
import { DialogTitle, DialogActions, Button, Divider } from '@material-ui/core'

export const ConfirmModal = ({ onClose, onSubmit, title }) => (
  <Fragment>
    <DialogTitle>{title}</DialogTitle>
    <Divider />
    <DialogActions>
      <Button onClick={onClose} color='secondary'>
        Ні
      </Button>
      <Button onClick={onSubmit} color='primary'>
        Так
      </Button>
    </DialogActions>
  </Fragment>
)


// WEBPACK FOOTER //
// ./src/components/EnhancedModal/components/ConfirmModal/ConfirmModal.js